import React from "react";
import PropTypes from "prop-types";

import { creativePreviewURL } from "utils/common";

import StatusColumn from "widgets/grid/cells/StatusColumn";

import "./ConflictsTable.css";

export default function ConflictsTable({ conflicts }) {
	const rows = conflicts.map((conflict) => {
		const { filename, id, approval, suffix } = conflict;
		const previewURL = creativePreviewURL(conflict);

		return (
			<tr key={`${filename}-${id}`}>
				<td className="creative-name-column">
					<div className="content-container">
						<span title={filename} className="name-overflow">
							<a href={previewURL} target="_blank">{filename}</a>
						</span>
						<div className="suffix">{suffix}</div>
					</div>
				</td>
				<td className="id-col creative-id-column">
					{id}
				</td>
				<td className="status-col creative-status-column">
					<StatusColumn
						value={approval}
					/>
				</td>
			</tr>
		);
	});

	return (
		<table className="basic-table">
			<thead>
				<tr>
					<th className="creative-name-column">File Name</th>
					<th className="id-col creative-id-column">ID</th>
					<th className="status-col creative-status-column">Status</th>
				</tr>
			</thead>
			<tbody>
				{rows}
			</tbody>
		</table>
	);
}

ConflictsTable.displayName = "ConflictsTable";
ConflictsTable.propTypes = {
	conflicts: PropTypes.arrayOf(PropTypes.shape({
		filename: PropTypes.string,
		id: PropTypes.oneOfType([
			PropTypes.number, PropTypes.string
		]),
		approval: PropTypes.string,
		suffix: PropTypes.string,
	})),
};

ConflictsTable.defaultProps = {
	conflicts: [],
};
